import React from 'react';
import { SparkModalPortal, Modal as SparkModal } from '@spark';

/**
 * Confirmation dialog for deleting a tag (and all its annotations) from the
 * "Available tags" legend of the NER annotate modal. Pairs with the
 * `deleteConfirm` state returned by `useNerTagCatalog`.
 */
export default function NerTagDeleteConfirmModal({ visible, tag, onConfirm, onCancel }) {
    return (
        <SparkModalPortal open={visible} onClose={onCancel} size="text">
            <SparkModal
                className="ner-confirm-modal"
                title={`Delete tag "${tag}"?`}
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showFooter
                danger
                primaryLabel="Delete"
                primaryDisableWhenReadOnly
                tertiaryLabel="Cancel"
                onPrimaryClick={onConfirm}
                onTertiaryClick={onCancel}
                onCloseClick={onCancel}
            >
                <div className="ner-confirm-modal-body">
                    <div>
                        Are you sure you want to delete the tag &quot;{tag}&quot; and all its
                        annotations from this record? This action cannot be undone.
                    </div>
                </div>
            </SparkModal>
        </SparkModalPortal>
    );
}
